<template>
  <div class="what-we-provide-component">
    <div class="box">
      <b-tag
        type="is-accent is-uppercase has-text-weight-semibold"
        class="has-margin-bottom-15"
        >THE PROBLEM</b-tag
      >
      <h3 class="title is-size-4 is-size-5-touch has-padding-bottom-5">
        Synchronized video apps can get complicated.
      </h3>
      <p class="subtitle is-size-5 is-size-6-touch">
        We learned the hard way.
      </p>
      <hr />
      <div class="columns">
        <div
          class="column"
          v-for="problem in problems"
          v-bind:key="problem.numTitle"
        >
          <h3
            class="is-size-1 is-size-2-mobile has-text-weight-medium"
            v-bind:class="problem.color"
          >
            {{ problem.numTitle }}
          </h3>
          <p class="has-text-weight-bold is-size-5">
            {{ problem.title }}
          </p>
          <p class="is-size-6">{{ problem.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WhatWeProvideComponent",
  data() {
    return {
      problems: [
        {
          numTitle: "01",
          color: "has-text-success",
          title: "Timing",
          description: "The reconciliation of inconsistent device times."
        },
        {
          numTitle: "02",
          color: "has-text-info",
          title: "EXIF Data",
          description:
            "Extraction and management of EXIF data from different devices."
        },
        {
          numTitle: "03",
          color: "has-text-warning",
          title: "Backend Baggage",
          description: "Server-side maintenance and security."
        },
        {
          numTitle: "04",
          color: "has-text-danger",
          title: "Video Management",
          description:
            "Storage, sequencing, formatting, performance optimization, and more."
        }
      ]
    };
  }
};
</script>
